import MsOfficeIcon from "../../../assets/icons/ms-office-360.svg";
import { Col } from "reactstrap";
import { Link } from "react-router-dom";
import Linked from './Linked';
import FeatureLock from "../../../components/FeatureLock/FeatureLock";
import { FEATURE_IDS } from "../../../constants/featureAccess";
import { OUTLOOK_CALENDAR_ID } from '../../../data/integration-app';

const Office365Calendar = ({connectedVenues}) => {
    return (
        <Col md="6" xxl="3" xl="4">
            <FeatureLock featureId={FEATURE_IDS.CALENDAR_INTEGRATIONS}>
                <Link to="/admin/calendar-integration" className="int-col">
                {connectedVenues.some(data => parseInt(data.app_id) === OUTLOOK_CALENDAR_ID) && <Linked />}
                <div className="img">
                    <img src={MsOfficeIcon} alt="Office 365 Calendar" />
                </div>
                <div className="text">
                    <h3>Office 365 Calendar</h3>
                    <p>
                    Manage your schedule with Outlook Calendar — organize meetings, events, and reminders seamlessly.
                    </p>
                </div>
                </Link>
            </FeatureLock>
        </Col>
    );
}

export default Office365Calendar;
